import { useToast } from "../shared/components/toast/useToast";
import { CircleCheck, TriangleAlert } from "lucide-react";

const useToastWrapper = () => {
  const { toast } = useToast();

  const SuccessToast = (text) => (
    <div className="flex flex-row gap-x-1 items-center">
      <CircleCheck color="#14b817" />
      {text}
    </div>
  );

  const ErrorToast = (text) => (
    <div className="flex flex-row gap-x-1 items-center">
      <TriangleAlert />
      {text}
    </div>
  );

  return {
    success: (text) => {
      toast({ description: SuccessToast(text) });
    },
    warning: (text) => {
      toast({
        title: "Acción no permitida",
        description: text,
        variant: "destructive",
      });
    },
    error: (text) => {
      toast({
        title: "Error en la aplicación",
        description: ErrorToast(text),
        variant: "destructive",
      });
    },
  };
};

export default useToastWrapper;
